//
// Module for the DRO Setup wizard's Account Balance step
//
rs.module("participant/benefit/setup/dro/wizard/accountbalancestep",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors, codeValues) {

            // Get the wizard Back button
            var wizardBackButton = $(`[data-wizard]`).js("_back");

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);

            var calculationMethodSelect = stepContainer.js(jsSelectors.calculationMethodSelect);
            var percentageInput = stepContainer.js(jsSelectors.percentageInput);

            // On initialize of page, we don't ever want to go back and attempt making duplicate claims
            wizardBackButton.setDisabled();

            // toggle based on Calculation Method
            calculationMethodSelect.change(function () {
                var disable = calculationMethodSelect.val() != codeValues.calculationMethodPercent;

                percentageInput.val("").prop("disabled", disable).clearErrors();
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);